import React from "react";
import SaveIcon from '@mui/icons-material/SaveRounded';
import CloseIcon from '@mui/icons-material/CloseRounded';
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import TextField from '@mui/material/TextField';
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import ApiSms from "../../../core/api/api.sms";


export const AddEditeModal = ({ showModalSmsInfo, setShowModalSmsInfo, selectedSms }) => {
  const { handleSubmit, control, formState: { errors, isSubmitting } } = useForm({
    defaultValues: { id: "" }
  });
  const handleClose = () => {
    setShowModalSmsInfo(false);
  }

  const onSubmit =
    async (data) => {
      try {
        console.log("onSubmit data=", data);

        let response = await ApiSms.sendGroupSms(data);
        console.log("response: ", response);

        if (response.succeeded == true)
          (document.getElementById('submitButton')).click();

        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      } catch (error) {
        console.log("error=", error);
      }
    }

  return (
    <div>
      {/* Start Modal */}
      <Modal centered size='md' onHide={handleClose} show={showModalSmsInfo}>
        <form id="form" onSubmit={handleSubmit(onSubmit)} >
          <Modal.Header closeButton>
            <Modal.Title>ارسال اسمس</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs='12'>
                توجه : لطفا جهت جدا کردن شماره موبایل ها از کاراکتر - استفاده نمایید.
                            </Col>
            </Row>
            <Row>
              <Col xs='12'>
                <Controller
                  name="mobileList"
                  control={control}
                  rules={{ required: "true" }}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="شماره موبایل ها"
                      margin="normal"
                      variant="outlined"
                      size='small'
                      multiline
                      rowsMax="10"
                      value={value || ""}
                      onInput={onChange}
                      sx={{
                        ".css-1b76txz-MuiInputBase-root-MuiOutlinedInput-root": {
                          padding: "8.5px 14px 8.5px 0px !important",
                        }
                      }}
                    />
                  )}
                />
                {errors.mobileList && <span>لطفا شماره موبایل را وارد نمایید</span>}
              </Col>
              <Col xs='12'>
                <Controller
                  name="text"
                  control={control}
                  rules={{ required: "true" }}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="متن پیام"
                      margin="normal"
                      variant="outlined"
                      size='small'
                      multiline
                      rowsMax="10"
                      value={value || ""}
                      onInput={onChange}
                      sx={{
                        ".css-1b76txz-MuiInputBase-root-MuiOutlinedInput-root": {
                          padding: "8.5px 14px 8.5px 0px !important",
                        }
                      }}
                    />
                  )}
                />
                {errors.text && <span>لطفا متنی را وارد نمایید</span>}
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting} >
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ارسال
                        </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon />  بستن
                        </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
}
